import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=4249151b&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&lang=ts&"
export * from "./UserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./user_info.scss?vue&type=style&index=0&id=4249151b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249151b",
  null
  
)

export default component.exports